import * as React  from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { AppcodeComponent } from "./components/appcode-component";
import { PromotionComponent } from "./components/promotion-component";
import { LoginComponent } from "./components/login-component";
import SearchBar from "./components/search/search";
import { AddPointsToRecipents } from "./components/addPoints/addpoints-component";
import {
  AppCtx,
  AppContextInterface,
} from "../../app/scripts/components/common/context";
import { AddBehaviour } from "./components/addBehaviour/addbehaviour-component";
import { ReviewandSubmit } from "./components/review/review";
import { Provider } from "react-redux";
import { createStore, compose } from "redux";
import combineReducers from "./reducers/mainReducer";
import { AnimatePresence } from "framer-motion";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { SuccessSSo } from "./components/successAuthentication/successAuthentication";

const sampleAppContext: AppContextInterface = {
  token: localStorage.getItem("appToken") || "{}",
  behaviour: "",
};

const composeEnhancers =
  window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
const store = createStore(combineReducers, composeEnhancers());

export const App = () => {

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <AnimatePresence exitBeforeEnter>
            <Switch>
              <Route exact path="/">
                <AppcodeComponent />
              </Route>
              <Route exact path="/login">
                <LoginComponent />
              </Route>
              <Route exact path="/promotions/:token/:host/:context">
                <PromotionComponent />
              </Route>
              <Route exact path="/search/:token">
                <AppCtx.Provider value={sampleAppContext}>
                  <SearchBar />
                </AppCtx.Provider>
              </Route>
              <Route exact path="/addrecipients">
                <AppCtx.Provider value={sampleAppContext}>
                  <AddPointsToRecipents />
                </AppCtx.Provider>
              </Route>
              <Route exact path="/addbehaviours">
                <AppCtx.Provider value={sampleAppContext}>
                  <AddBehaviour />
                </AppCtx.Provider>
              </Route>
              <Route exact path="/review">
                <AppCtx.Provider value={sampleAppContext}>
                  <ReviewandSubmit />
                </AppCtx.Provider>
              </Route>
              <Route exact path="/success/:token/:language">
                <SuccessSSo />
              </Route>
            </Switch>
          </AnimatePresence>
        </Router>
      </I18nextProvider>
    </Provider>
  );
};
